export interface UserDealer {  
  dealerAccountUid: string;
  dealerName: string;
  permissions: Array<string>;  
  isChainGroup: boolean;
}

export interface UserStateInterface {
  id: string | null;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string | null;
  permissions: Array<string>;
  activeDealerAccountUid: string | null;
  dealers: Array<UserDealer>;
  dealerRoles: Array<string>;
  hasFullRights: boolean;
}

function state(): UserStateInterface {
  return {
    id : null,
    email: null,
    firstName: null,
    lastName: null,
    phoneNumber: null,
    permissions: [],
    activeDealerAccountUid: null,
    dealers: [],
    dealerRoles: [],
    hasFullRights: false   
  }
}

export default state;
